import SideMenu from '@/containers/side-menu/SideMenu.vue'
import VehicleHistory from '@/pages/vehicle-history/VehicleHistory'

export default  [
  {
    path: '/vehicle-history',
    name: 'VehicleHistory',
    components: {
      mainContent: VehicleHistory,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'vehicle-history'
      },
      breadcrumb: {
        title: 'Histórico do Veículo',
        paths: [
          { title: 'Veículo' },
          { title: 'Histórico' }
        ]
      }
    }
  },
  {
    path: '/vehicle-history/:licencePlate',
    name: 'VehicleHistoryWithLicencePlate',
    components: {
      mainContent: VehicleHistory,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'vehicle-history'
      },
      breadcrumb: {
        title: 'Histórico do Veículo',
        paths: [
          { title: 'Veículo' },
          { title: 'Histórico' }
        ]
      }
    }
  }
]